module.exports = __webpack_public_path__ + "img/social-ok.2190d287.svg";